export default {
	title: "Web3",
	rule: "Regelbeskrivning",
	safe: "Fondssäkerhet",
	balance: {
		total: "Totalt belopp",
		yesterday: "Igårs intäkter",
		cumulatively: "Kumulativa intäkter",
		in: "Insättning",
		out: "Uttag",
		available: "Tillgänglig saldo"
	},
	actions: {
		in: "Insätta",
		out: "Uttaga"
	},
	type: ["Alla", "Insättning", "Uttag", "Intäkter"],
	TransactionPassword: "Transaktionslösenord",
	Amount: "Montant",
	date: "Date"
};
